var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState } from "react";
import Cookies from "js-cookie";
import sortArray from "sort-array";
var JesuisJechercheContext = createContext();
export var JesuisJechercheProvider = function (_a) {
    var _b;
    var children = _a.children;
    var langCode = ((_b = document.getElementById("language-code")) === null || _b === void 0 ? void 0 : _b.value) || "en";
    var getCurrentUserId = document.getElementById("current-auth-user-id").value;
    var currentUserFirstName = document.getElementById("current-auth-user-first-name").value;
    var currentUserLastName = document.getElementById("current-auth-user-last-name").value;
    var currentUserCompanyName = document.getElementById("current-auth-user-company-name").value;
    var currentUserCompanyId = document.getElementById("current-auth-user-company-id").value;
    // State for projects
    var _c = __read(useState([]), 2), projects = _c[0], setProjects = _c[1];
    var _d = __read(useState(true), 2), projectsIsLoading = _d[0], setProjectsIsLoading = _d[1];
    var _e = __read(React.useState(0), 2), page = _e[0], setPage = _e[1];
    var _f = __read(useState(0), 2), pageCount = _f[0], setPageCount = _f[1];
    var _g = __read(useState(""), 2), nextProjects = _g[0], setNextProjects = _g[1];
    var _h = __read(useState("defaultView"), 2), view = _h[0], setView = _h[1];
    // Filter States
    var categories = [
        {
            label_fr: "Donneurs d'ordres",
            label_en: "Contracting Authorities",
            value: "contractor",
        },
        {
            label_fr: "Fournisseurs",
            label_en: "Suppliers",
            value: "supplier",
        },
        {
            label_fr: "Intervenants",
            label_en: "Interveners",
            value: "intervenant",
        }
    ];
    var _j = __read(useState(false), 2), filtersIsLoading = _j[0], setFiltersIsLoading = _j[1];
    var _k = __read(React.useState([]), 2), selectedCategory = _k[0], setSelectedCategory = _k[1];
    var _l = __read(React.useState(""), 2), yearInput = _l[0], setYearInput = _l[1];
    var _m = __read(React.useState([]), 2), months = _m[0], setMonths = _m[1];
    var _o = __read(useState([]), 2), rows = _o[0], setRows = _o[1];
    //state for infinite scroll
    var _p = __read(useState(false), 2), newProjectIsLoading = _p[0], setNewProjectIsLoading = _p[1];
    var _q = __read(useState(false), 2), hasMoreData = _q[0], setHasMoreData = _q[1];
    //elements/ items Count used in info bar
    var _r = __read(React.useState(0), 2), count = _r[0], setCount = _r[1];
    //Search State for search bar
    var _s = __read(useState(""), 2), searchInput = _s[0], setSearchInput = _s[1];
    var _t = __read(useState(""), 2), searchedTerm = _t[0], setSearchedTerm = _t[1];
    //States for comments
    var _u = __read(useState({}), 2), comments = _u[0], setComments = _u[1];
    var _v = __read(useState(false), 2), commentEditing = _v[0], setCommentEditing = _v[1];
    var _w = __read(useState(""), 2), commentIdToEdit = _w[0], setCommentIdToEdit = _w[1];
    var _x = __read(useState(""), 2), enteredComment = _x[0], setEnteredComment = _x[1];
    var _y = __read(React.useState(null), 2), commentsToShow = _y[0], setCommentsToShow = _y[1];
    // Modal State
    var _z = __read(useState(false), 2), confirmationModalIsOpen = _z[0], setConfirmationModalIsOpen = _z[1];
    var normalizeResults = function (results) {
        if (results === void 0) { results = []; }
        return results.map(function (entry) { var _a; return (_a = entry.result) !== null && _a !== void 0 ? _a : entry; });
    };
    var getComparableDate = function (project) {
        if (!project) {
            return 0;
        }
        var candidate = project.date_publication_avis ||
            project.date_creation ||
            project.date_modified;
        var timestamp = candidate ? Date.parse(candidate) : Number.NaN;
        return Number.isNaN(timestamp) ? 0 : timestamp;
    };
    var sortByPublicationDateDesc = function (items) {
        if (items === void 0) { items = []; }
        return __spreadArray([], __read(items), false).sort(function (a, b) { return getComparableDate(b) - getComparableDate(a); });
    };
    // Fetch Projects
    // Define an asynchronous function fetchProjects
    var fetchProjects = function (queryString, page, rowsList) {
        if (queryString === void 0) { queryString = ""; }
        if (page === void 0) { page = 1; }
        if (rowsList === void 0) { rowsList = []; }
        return __awaiter(void 0, void 0, void 0, function () {
            // Define an asynchronous function postData to send a POST request with the query
            function postData(url, data) {
                if (url === void 0) { url = "/".concat(langCode, "/api/search/"); }
                if (data === void 0) { data = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var response;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, fetch(url, {
                                    method: "POST",
                                    mode: "cors",
                                    cache: "no-cache",
                                    credentials: "same-origin",
                                    headers: {
                                        "X-CSRFToken": CSRF_TOKEN,
                                        "Content-Type": "application/json",
                                    },
                                    redirect: "follow",
                                    referrerPolicy: "no-referrer",
                                    body: JSON.stringify(data),
                                })];
                            case 1:
                                response = _a.sent();
                                return [4 /*yield*/, response.json()];
                            case 2: return [2 /*return*/, _a.sent()];
                        }
                    });
                });
            }
            var CSRF_TOKEN, defaultConditions, query;
            return __generator(this, function (_a) {
                // Set a loading state to true, indicating that projects are being fetched
                setProjectsIsLoading(true);
                CSRF_TOKEN = Cookies.get("csrftoken");
                defaultConditions = [
                    {
                        condition: "where",
                        field: "project_type",
                        operator: "is",
                        value: "jesuis_jecherche",
                    },
                    {
                        condition: "where",
                        field: "visible_jesuis_jecherche",
                        operator: "is",
                        value: true,
                    },
                ];
                query = {
                    query: queryString,
                    page: page,
                    filters: [
                        {
                            Project: {
                                conditions: __spreadArray(__spreadArray([], __read(defaultConditions), false), __read(rowsList), false),
                                sort: {
                                    date_publication_avis: {
                                        order: "desc",
                                    },
                                }
                            },
                        },
                    ],
                };
                // Call postData with the specified URL and query
                postData("/".concat(langCode, "/api/search/"), query).then(function (data) {
                    // Process the response data
                    var newProjects = normalizeResults(data.results);
                    var orderedProjects = sortByPublicationDateDesc(newProjects);
                    setPageCount(Math.ceil(data.count / 10));
                    data.next ? setHasMoreData(true) : setHasMoreData(false);
                    setNextProjects(data.next);
                    setProjects(orderedProjects);
                    setCount(data.count);
                    // Set loading state to false, indicating that projects have been fetched
                    setProjectsIsLoading(false);
                });
                return [2 /*return*/];
            });
        });
    };
    //loadNewProjects
    var loadNewProjects = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (newProjectIsLoading || !hasMoreData) {
                return [2 /*return*/];
            }
            setNewProjectIsLoading(true);
            fetch("".concat(nextProjects))
                .then(function (response) { return response.json(); })
                .then(function (data) {
                data.next ? setHasMoreData(true) : setHasMoreData(false);
                setNextProjects(data.next);
                var fetchedProjects = normalizeResults(data.results);
                setProjects(function (prevProjects) {
                    return sortByPublicationDateDesc(__spreadArray(__spreadArray([], __read(prevProjects), false), __read(fetchedProjects), false));
                });
            })
                .catch(function (e) { return console.log(e); });
            setNewProjectIsLoading(false);
            return [2 /*return*/];
        });
    }); };
    //get title
    var getTitle = function (langCode) {
        return langCode === "fr"
            ? "Je cherche/J'offre"
            : "I am looking for/I am Offering";
    };
    //handle key down for search bar
    var fetchComments = function (projectId, page) {
        if (page === void 0) { page = 1; }
        return __awaiter(void 0, void 0, void 0, function () {
            // Define an asynchronous function postData to send a POST request with the query
            function postData(url, data) {
                if (url === void 0) { url = "/".concat(langCode, "/api/search/"); }
                if (data === void 0) { data = {}; }
                return __awaiter(this, void 0, void 0, function () {
                    var response;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, fetch(url, {
                                    method: "POST",
                                    mode: "cors",
                                    cache: "no-cache",
                                    credentials: "same-origin",
                                    headers: {
                                        "X-CSRFToken": CSRF_TOKEN,
                                        "Content-Type": "application/json",
                                    },
                                    redirect: "follow",
                                    referrerPolicy: "no-referrer",
                                    body: JSON.stringify(data),
                                })];
                            case 1:
                                response = _a.sent();
                                return [2 /*return*/, response.json()];
                        }
                    });
                });
            }
            var CSRF_TOKEN, query;
            return __generator(this, function (_a) {
                CSRF_TOKEN = Cookies.get("csrftoken");
                query = {
                    query: "",
                    page: page,
                    filters: [
                        {
                            Comment: {
                                conditions: [
                                    {
                                        condition: "where",
                                        field: "object_id",
                                        operator: "is",
                                        value: projectId,
                                    },
                                ],
                            },
                        },
                    ],
                };
                // Call postData with the specified URL and query
                postData("/".concat(langCode, "/api/search/"), query).then(function (data) {
                    // Process the response data
                    var newComments = data.results.map(function (data) { return data.result; });
                    setComments(function (oldComments) {
                        var _a;
                        return (__assign(__assign({}, oldComments), (_a = {}, _a[projectId] = newComments, _a)));
                    });
                });
                return [2 /*return*/];
            });
        });
    };
    var handleKeyDown = function (event) {
        if (event.key === "Enter") {
            setPage(0);
            setSearchedTerm(searchInput);
        }
    };
    // search projects from the lists for search bar
    var searchProjects = function () {
        setPage(0);
        setSearchedTerm(searchInput);
    };
    var handleSearchInput = function (e) {
        setSearchInput(e.target.value);
    };
    // Create Comment
    var CSRF_TOKEN = Cookies.get("csrftoken");
    var createComment = function (e, projectId) { return __awaiter(void 0, void 0, void 0, function () {
        var capitalizeFirstLetter;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    capitalizeFirstLetter = function (str) {
                        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
                    };
                    if (!enteredComment) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetch("/".concat(langCode, "/api/comments/create-comment/"), {
                            method: "POST",
                            mode: "cors",
                            cache: "no-cache",
                            credentials: "same-origin",
                            headers: {
                                "X-CSRFToken": CSRF_TOKEN,
                                "Content-Type": "application/json",
                            },
                            redirect: "follow",
                            referrerPolicy: "no-referrer",
                            body: JSON.stringify({
                                content: enteredComment,
                                object_id: projectId,
                                author: parseInt(getCurrentUserId),
                                username: "".concat(capitalizeFirstLetter(currentUserFirstName), " ").concat(capitalizeFirstLetter(currentUserLastName)),
                                company: {
                                    id: currentUserCompanyId,
                                    name: currentUserCompanyName,
                                },
                            }),
                        })
                            .then(function (response) { return response.json(); })
                            .then(function (comment) {
                            setComments(function (oldComments) {
                                var _a;
                                return (__assign(__assign({}, oldComments), (_a = {}, _a[projectId] = __spreadArray(__spreadArray([], __read(oldComments[projectId]), false), [comment], false), _a)));
                            });
                        })];
                case 1:
                    _a.sent();
                    resetCommentInputs();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    // Edit Comment
    var editComment = function (e, projectId, commentId) { return __awaiter(void 0, void 0, void 0, function () {
        var projectComments, existingComment;
        return __generator(this, function (_a) {
            projectComments = comments[projectId];
            existingComment = projectComments.filter(function (c) { return c.id === commentId; })[0];
            setCommentEditing(true);
            setCommentIdToEdit(commentId);
            setEnteredComment(existingComment.content);
            return [2 /*return*/];
        });
    }); };
    var updateComment = function (e, projectId, commentId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!enteredComment) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetch("/".concat(langCode, "/api/comments/update-comment/").concat(commentId, "/"), {
                            method: "PUT",
                            mode: "cors",
                            cache: "no-cache",
                            credentials: "same-origin",
                            headers: {
                                "X-CSRFToken": CSRF_TOKEN,
                                "Content-Type": "application/json",
                            },
                            redirect: "follow",
                            referrerPolicy: "no-referrer",
                            body: JSON.stringify({ content: enteredComment }),
                        }).then(function () {
                            var updatedComments = comments[projectId].map(function (commentObj) {
                                var _a;
                                if (commentObj.object_id === projectId) {
                                    return __assign(__assign({}, commentObj), { comments: ((_a = commentObj.comments) !== null && _a !== void 0 ? _a : []).map(function (comment) {
                                            return comment.id === commentId
                                                ? __assign(__assign({}, comment), { content: enteredComment }) : comment;
                                        }) });
                                }
                                return commentObj;
                            });
                            setComments(updatedComments);
                            fetchComments(projectId);
                        })];
                case 1:
                    _a.sent();
                    resetCommentInputs();
                    setCommentEditing(false);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    // Delete Comment
    var deleteComment = function (e, projectId, commentId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("/".concat(langCode, "/api/comments/delete-comment/").concat(commentId, "/"), {
                        method: "DELETE",
                        mode: "cors",
                        cache: "no-cache",
                        credentials: "same-origin",
                        headers: {
                            "X-CSRFToken": CSRF_TOKEN,
                            "Content-Type": "application/json",
                        },
                        redirect: "follow",
                        referrerPolicy: "no-referrer",
                    }).then(function () {
                        var updatedComments = comments[projectId].map(function (commentObj) {
                            if (commentObj.project_id === projectId) {
                                var newResponseNbr = commentObj.responseNbr - 1;
                                var updatedComments_1 = commentObj.comments.filter(function (comment) { return comment.id !== commentId; });
                                return __assign(__assign({}, commentObj), { comments: updatedComments_1, responseNbr: newResponseNbr });
                            }
                            return commentObj;
                        });
                        setComments(updatedComments);
                        fetchComments(projectId);
                        fetchProjects();
                    })];
                case 1:
                    _a.sent();
                    setConfirmationModalIsOpen(false);
                    return [2 /*return*/];
            }
        });
    }); };
    // Reset Comment Inputs
    var resetCommentInputs = function () {
        setEnteredComment("");
        setCommentIdToEdit("");
    };
    // Get Comments
    // const showComments = async (projectId) => {
    //     const response = await fetch(`/${langCode}/api/projects/${projectId}/comments/?limit=5000`);
    //     const data = await response.json();
    //     const newComments = {project_id: projectId, comments: data.results, responseNbr: data.results.length};
    //
    //     const commentId = comments.findIndex(obj => obj.project_id === projectId);
    //
    //     // when there are comments
    //     if (commentId !== -1) {
    //         const updatedComments = comments.map((comment) => {
    //             if (comment.project_id === projectId) {
    //                 return newComments;
    //             }
    //             return comment;
    //         });
    //         setComments(updatedComments);
    //     } else {
    //         setComments([...comments, newComments]);
    //     }
    //
    //     displayComments(projectId);
    // };
    var displayComments = function (projectId) {
        if (commentsToShow === projectId) {
            setCommentsToShow(null);
        }
        else {
            setCommentsToShow(projectId);
        }
    };
    var handleComment = function (e) {
        setEnteredComment(e.target.value);
    };
    // highest order
    function getHighestOrder(array) {
        var highestPrice = 99999999;
        for (var i = 0; i < array.length; i++) {
            if (array[i].order > highestPrice) {
                highestPrice = array[i].order;
            }
        }
        return highestPrice;
    }
    //handle category change
    var handleCategoryChange = function (item) {
        setPage(0);
        //get latest selected
        var latestSelected = selectedCategory
            .filter(function (x) { return !item.includes(x); })
            .concat(item.filter(function (x) { return !selectedCategory.includes(x); }));
        var newCategory = {
            order: 99999999,
            condition: "and",
            field: "entreprise.type_company",
            operator: "is",
            value: latestSelected[0].value,
        };
        if (item.length > selectedCategory.length) {
            setSelectedCategory(item);
            if (rows.some(function (obj) { return Object.values(obj).includes("entreprise.type_company"); })) {
                var indx = rows.findIndex(function (obj) { return obj["field"] === "entreprise.type_company"; });
                newCategory.order = rows[indx].order;
                newCategory.condition = "or";
            }
            else {
                var bigOrder = getHighestOrder(rows);
                newCategory.order = bigOrder + 1;
            }
            setRows(function (prevStat) {
                return __spreadArray(__spreadArray([], __read(prevStat), false), [newCategory], false);
            });
        }
        else {
            //get the removed option
            var removedOption_1 = selectedCategory
                .filter(function (x) { return !item.includes(x); })
                .concat(item.filter(function (x) { return !selectedCategory.includes(x); }));
            setSelectedCategory(item);
            setRows(function () {
                return rows.filter(function (item) {
                    return item.value !== removedOption_1[0].value;
                });
            });
        }
    };
    //Handle Year change
    var handleYear = function (e) {
        setPage(0);
        var newValue = e.target.value;
        var newYear = {
            order: 0,
            type: "year",
            condition: "and",
            field: "date_publication_avis",
            operator: "between",
            value: ["".concat(newValue, "-01-01"), "".concat(newValue, "-12-31")],
        };
        if (newValue != "") {
            setYearInput(newValue);
            if (months.length == 0) {
                if (rows.findIndex(function (row) { return row.field === "date_publication_avis"; }) == -1) {
                    setRows(function (prevStat) { return __spreadArray(__spreadArray([], __read(prevStat), false), [newYear], false); });
                }
                else {
                    var rowsCopy = __spreadArray([], __read(rows), false);
                    var rowIndex = rowsCopy.findIndex(function (row) { return row.field === "date_publication_avis"; });
                    if (rowIndex !== -1) {
                        var rowsCopy_1 = __spreadArray([], __read(rows), false);
                        var rowIndex_1 = rowsCopy_1.findIndex(function (row) { return row.field === "date_publication_avis"; });
                        if (rowIndex_1 !== -1) {
                            rowsCopy_1[rowIndex_1] = __assign(__assign({}, rowsCopy_1[rowIndex_1]), { value: ["".concat(newValue, "-01-01"), "".concat(newValue, "-12-31")] });
                            setRows(rowsCopy_1);
                        }
                    }
                }
            }
            else {
                try {
                    setRows(function (row) {
                        return row.map(function (obj) {
                            var updatedValue = obj.field === "date_publication_avis" && obj.value
                                ? obj.value.map(function (date) { return date.replace(/^.{4}/, newValue); })
                                : obj.value;
                            return __assign(__assign({}, obj), { value: updatedValue });
                        });
                    });
                }
                catch (error) {
                    console.error("Error updating year:", error);
                }
            }
            if (rows.some(function (obj) { return Object.values(obj).includes("date_publication_avis"); })) {
                var indx = rows.findIndex(function (obj) { return obj["field"] === "date_publication_avis"; });
                newYear.order = rows[indx].order;
            }
            else {
                var bigOrder = getHighestOrder(rows);
                newYear.order = bigOrder + 1;
            }
        }
        else {
            setYearInput("");
            setRows(function () { return rows.filter(function (row) { return row.type != "year"; }); });
        }
    };
    // Handle month change
    var getDaysInMonth = function (month, year) {
        if (!year || year == "") {
            year = new Date().getFullYear();
        }
        // Create a new date object and set the day to 0
        var date = new Date(year, month, 0);
        // Return the number of days in the month
        return date.getDate();
    };
    var handleMonthChange = function (month) {
        setPage(0);
        //get latest selected
        var latestSelected = months
            .filter(function (x) { return !month.includes(x); })
            .concat(month.filter(function (x) { return !months.includes(x); }));
        var nbrDays = getDaysInMonth(latestSelected[0].value, yearInput);
        var monthNbr = latestSelected[0].value;
        var newMonth = {
            order: 0,
            monthId: monthNbr,
            condition: "or",
            field: "date_publication_avis",
            operator: "between",
            value: [
                "".concat(yearInput || new Date().getFullYear(), "-").concat(monthNbr < 10 ? "0" : "").concat(monthNbr, "-01"),
                "".concat(yearInput || new Date().getFullYear(), "-").concat(monthNbr < 10 ? "0" : "").concat(monthNbr, "-").concat(nbrDays),
            ],
        };
        if (month.length > months.length) {
            setMonths(month);
            if (rows.some(function (obj) { return Object.values(obj).includes("date_publication_avis"); })) {
                var indx = rows.findIndex(function (obj) { return obj["field"] === "date_publication_avis"; });
                newMonth.order = rows[indx].order;
            }
            else {
                var bigOrder = getHighestOrder(rows);
                newMonth.order = bigOrder + 1;
            }
            setRows(function (prevState) {
                return __spreadArray(__spreadArray([], __read(prevState), false), [newMonth], false);
            });
        }
        else {
            //get the removed option
            var removedOption_2 = months
                .filter(function (x) { return !month.includes(x); })
                .concat(month.filter(function (x) { return !months.includes(x); }));
            setMonths(month);
            setRows(function () {
                return rows.filter(function (row) { return row.monthId != removedOption_2[0].value; });
            });
        }
    };
    //Reset filter
    var resetFilters = function () {
        setSelectedCategory([]);
        setMonths([]);
        setYearInput("");
        setProjects([]);
        setPage(0);
        fetchProjects();
    };
    React.useEffect(function () {
        fetchProjects();
    }, [langCode]);
    React.useEffect(function () {
        fetchProjects(searchInput !== searchedTerm ? searchInput : searchedTerm, page + 1);
    }, [searchedTerm]);
    React.useEffect(function () {
        if (projects)
            projects.forEach(function (p) { return fetchComments(p.id); });
    }, [projects]);
    //sort rows
    React.useEffect(function () {
        // Order by the first selected filter
        sortArray(rows, {
            by: ["order"],
        });
        var rowsCopy = __spreadArray([], __read(rows), false);
        // First, check if the first element is not "where"
        if (rowsCopy.length > 0 && rowsCopy[0].condition !== "where") {
            rowsCopy[0].condition = "where";
        }
        var searchData = {
            query: searchInput !== searchedTerm ? searchInput : searchedTerm,
            page: 1,
            filters: [
                {
                    Project: {
                        conditions: rowsCopy,
                        sort: {
                            date_publication_avis: {
                                order: "desc",
                            },
                        },
                    },
                },
            ],
        };
        fetchProjects(searchData["query"], 1, rowsCopy);
    }, [rows]);
    return (_jsx(JesuisJechercheContext.Provider, __assign({ value: {
            projects: projects,
            projectsIsLoading: projectsIsLoading,
            page: page,
            pageCount: pageCount,
            nextProjects: nextProjects,
            view: view,
            setView: setView,
            count: count,
            searchedTerm: searchedTerm,
            searchInput: searchInput,
            comments: comments,
            commentEditing: commentEditing,
            commentIdToEdit: commentIdToEdit,
            enteredComment: enteredComment,
            commentsToShow: commentsToShow,
            getCurrentUserId: getCurrentUserId,
            confirmationModalIsOpen: confirmationModalIsOpen,
            setConfirmationModalIsOpen: setConfirmationModalIsOpen,
            fetchProjects: fetchProjects,
            loadNewProjects: loadNewProjects,
            getTitle: getTitle,
            handleKeyDown: handleKeyDown,
            searchProjects: searchProjects,
            handleSearchInput: handleSearchInput,
            fetchComments: fetchComments,
            createComment: createComment,
            deleteComment: deleteComment,
            editComment: editComment,
            resetCommentInputs: resetCommentInputs,
            //getComments,
            displayComments: displayComments,
            handleComment: handleComment,
            updateComment: updateComment,
            //filters
            filtersIsLoading: filtersIsLoading,
            categories: categories,
            selectedCategory: selectedCategory,
            yearInput: yearInput,
            months: months,
            handleCategoryChange: handleCategoryChange,
            handleYear: handleYear,
            handleMonthChange: handleMonthChange,
            resetFilters: resetFilters,
            setFiltersIsLoading: setFiltersIsLoading,
            setSelectedCategory: setSelectedCategory,
            setYearInput: setYearInput,
            setMonths: setMonths,
        } }, { children: children })));
};
export var useJesuisJecherche = function () { return useContext(JesuisJechercheContext); };
export default JesuisJechercheContext;
